// import { Games as GamesView } from '@/features/Games/components/Games';

export const GameActivation = () => {
  return <div>Missing identifier token</div>;
};
